export const SHARED_FILE_REQUIREMENT_EVENT = {
  UploadFile: "UploadFile",
  SubmitFileAnyway: "SubmitFileAnyway",
  DownloadAsPayee: "DownloadAsPayee",
  DownloadAsPayer: "DownloadAsPayer",
  ValidationSuccess: "ValidationSuccess",
  SubmitForReview: "SubmitForReview"
} as const;

export const MAX_COI_FILE_UPLOAD_ATTEMPTS = 3;
